import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { ToastProvider } from './hooks/useToasts';

import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/sheet.css';
import './styles/map.css';
import './styles/screens.css';

const container = document.getElementById('root');
if (!container) throw new Error('Не найден контейнер #root');

createRoot(container).render(
  <StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </StrictMode>,
);
